// import ModalForm from "./Form";
import { COURSE_HISTORY } from "../../../../../Config/ApiUrl";
import * as actions from "../../../../../Config/ApiUrl";

export const StudentScheduleSchema = {
	components: {},

	data() {
		return {
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			ENDPOINT:
				COURSE_HISTORY +
				"?course_schedule_id=" +
				this.scheduleRowData?.course_schedule_id,
			tableId: "student-schedule-table",
			formId: "student-schedule-form",
			rowData: {},
			tableColumns: [
				{
					title: "CLC ID No",
					type: "text",
					key: "clc_id_number",
				},
				{
					title: "Full Name",
					type: "text",
					key: "full_name",
				},
			],
			actionObj: {
				title: "Schedule",
				type: "action",
			},
			options: {
				name: "ScheduleTable",
				url:
					COURSE_HISTORY +
					"?course_schedule_id=" +
					this.scheduleRowData?.course_schedule_id,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: false,
				columns: [],
				actions: [],
				filters: [],
				showFilter: false,
				showSearch: true,
				showCount: true,
				showClearFilter: false,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 5,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
